/**
 * V37.74 — Tunnel VEFA (programme immobilier).
 *
 * Page autonome de saisie + iframe du module navigateur statique
 * (`/contrats/vefa.html`). Affiche clairement que VEFA applique ses
 * propres garde-fous (different de CCMI) et que l'acte definitif doit
 * obligatoirement etre recu par notaire.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, ShieldCheck, AlertTriangle } from 'lucide-react';
import VefaAiAssistantPanel from '../components/VefaAiAssistantPanel';

export default function VefaTunnelPage() {
  return (
    <main className="min-h-screen bg-slate-100" data-testid="vefa-tunnel-page">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-5 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <Link
              to="/dispositifs-btp"
              className="inline-flex items-center gap-2 text-sm font-semibold text-blue-700 hover:text-blue-900"
              data-testid="vefa-back-link"
            >
              <ArrowLeft className="h-4 w-4" />
              Dispositifs BTP
            </Link>
            <h1 className="mt-3 text-2xl font-bold text-slate-950">
              Tunnel VEFA — programme immobilier
            </h1>
            <p className="mt-1 max-w-3xl text-sm text-slate-600">
              Contrat préliminaire de réservation, dossier notaire, appels de fonds plafonnés
              et contrôles de conformité VEFA (CCH L261-1 et s.).
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <span
              className="inline-flex items-center gap-2 rounded-full border border-blue-900 bg-blue-700 px-3 py-2 text-sm font-semibold text-white"
              data-testid="vefa-badge-modele"
            >
              <FileText className="h-4 w-4" />
              Modèle VEFA intégré
            </span>
            <span
              className="inline-flex items-center gap-2 rounded-full border border-amber-800 bg-amber-600 px-3 py-2 text-sm font-semibold text-white"
              data-testid="vefa-badge-notaire"
            >
              <ShieldCheck className="h-4 w-4" />
              Acte définitif notaire
            </span>
          </div>
        </div>
      </header>

      <section className="border-b border-amber-300 bg-amber-100" data-testid="vefa-warning-banner">
        <div className="mx-auto max-w-7xl px-4 py-3 text-sm font-semibold text-amber-900 flex items-start gap-2">
          <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
          <span>
            Le parcours VEFA applique ses propres règles : GFA/GFR, compte spécial, dépôt
            de garantie plafonné (5 % / 2 % / 0 % selon délai) et appels de fonds cumulés
            <strong> 35 / 70 / 95 / 100</strong>. Il ne reprend pas les garde-fous CCMI.
            L'acte définitif doit obligatoirement être reçu par notaire — il n'est jamais
            généré par la plateforme.
          </span>
        </div>
      </section>

      <iframe
        title="Module VEFA — Tunnel de vente"
        src="/contrats/vefa.html"
        className="h-[640px] w-full border-0"
        data-testid="vefa-tunnel-iframe"
      />

      <section className="bg-white border-t border-slate-200">
        <div className="mx-auto max-w-7xl px-4 py-6">
          <VefaAiAssistantPanel />
        </div>
      </section>
    </main>
  );
}
